import { render, staticRenderFns } from "./MduiRadioGroup.vue?vue&type=template&id=299e15e5&scoped=true"
import script from "./MduiRadioGroup.vue?vue&type=script&lang=js"
export * from "./MduiRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./MduiRadioGroup.vue?vue&type=style&index=0&id=299e15e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e15e5",
  null
  
)

export default component.exports